module.exports = __webpack_public_path__ + "img/uid-token-guide-bg.4dc6baa0.png";